import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/stages_of_scaling.png'


const _withScopeId = n => (_pushScopeId("data-v-b4b7c102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 text-primary pb-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "stages of scaling",
    class: "img-fluid"
  })
], -1))
const _hoisted_3 = { class: "card p-4" }
const _hoisted_4 = { class: "card-header bg-transparent" }
const _hoisted_5 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex mb-4",
        key: i
      }, [
        _createElementVNode("span", null, "stage " + _toDisplayString(i + 1), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", null, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.message), 1)
        ])
      ]))
    }), 128))
  ]))
}